import ErrorBox from '@components/common/ErrorBox';
import ProductBoutiqueSelected from '@stone/components/reserve/ProductBoutiqueSelected';
import Button from '@stone/ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import DwFormFieldPhoneWithPrefix from '@ui/formfield/DwFormFieldPhoneWithPrefix';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import { BAA } from '@utils/constants';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import BookAnAppointmentStoreSelector from '@stone/components/appointments/BookAnAppointmentStoreSelector';
import BookAnAppointmentReasonMessage from '@stone/components/appointments/BookAnAppointmentReasonMessage';
import BookAnAppointmentDateSelection from '@stone/components/appointments/BookAnAppointmentDateSelection';
import BookAnAppointmentPersonalInfo from '@stone/components/appointments/BookAnAppointmentPersonalInfo';
import BookAnAppointmentConfirmationPage from '@stone/components/appointments/BookAnAppointmentConfirmationPage';
import classNames from 'classnames';
import ClientServiceSection from '../clientService/ClientServiceSection';
import LoginModal from '../login/LoginModal';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import SubmitButton from '@stone/ui/button/SubmitButton';
const focusOnError = createDecorator(); // must be outside the component
const BookAnAppointmentForm = (props) => {
    const { t } = useTranslation();
    const [requestSent, setRequestSent] = useState();
    const [appointmentresponse, setAppointmentresponse] = useState();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = useState([]);
    const [days, setDays] = useState({});
    const [store, setStore] = useState(props.store);
    const [appointmentType, setAppointmentType] = useState(BAA.APPOINTMENT.INSTORE);
    const [collections, setCollections] = useState([]);
    const appointmentSection = useRef(null);
    const [resetFields, setResetFields] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    const [reasonSelect, setReasonSelect] = useState();
    const [availableSlotTypes, setAvailableSlotTypes] = useState();
    const tabsMap = {
        '552250000': t('bookanappointment.appointmentinstoreanalytics'),
        '552250001': t('bookanappointment.virtualappointmentanalytics'),
    };
    const lastArg = useRef();
    // ANCHOR - USE EFFECTS --------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        let val = {};
        api.getForm('bookanappointment', val, true).then((data) => {
            var _a;
            if (!val.appointmenttype) {
                val.appointmenttype = BAA.APPOINTMENT.INSTORE;
            }
            // if (props.type == 'mbm' && !val.reason) {
            //   val.reason = BAA.REASONS.PERSONALIZATION;
            // }
            // filtra la personalization reason in base alla global preference activateMbmReasonContact
            if (!window.mbmContactReason) {
                data.reason.options = data.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION);
            }
            // store without personalization room, filter it out from reasons
            if (props.type == 'modal' && !((_a = store === null || store === void 0 ? void 0 : store.storeServices) === null || _a === void 0 ? void 0 : _a.personalizationRoom)) {
                data.reason.options = data.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION);
            }
            if (props.recipeid) {
                val.recipeid = props.recipeid;
                val.size = props.size;
            }
            if (isMounted) {
                if (appointmentType != val.appointmenttype) {
                    setAppointmentType(val.appointmenttype);
                }
                setInitialValues(val);
                setFormdef(data);
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);
    useEffect(() => {
        if (store) {
            api.bookAnAppointmentSlots(store === null || store === void 0 ? void 0 : store.ID, appointmentType != BAA.APPOINTMENT.VIRTUAL ? availableSlotTypes : appointmentType, false, reasonSelect).then((data) => {
                setDays(data.days);
            });
            api.bookAnAppointmentCollections(store === null || store === void 0 ? void 0 : store.ID).then((data) => {
                setCollections(data);
            });
        }
    }, [store, appointmentType]);
    useLayoutEffect(() => {
        if (requestSent && appointmentresponse && props.type === 'modal') {
            const scrollDom = document.querySelector('.modal.bookanappointment .modal__body--right');
            scrollDom.scroll({ top: 0 });
        }
    }, [props.type, requestSent, appointmentresponse]);
    //* ANCHOR - FUNCTIONS --------------------------------------------------------------------
    const prefillValues = (values) => {
        values.storeid = store === null || store === void 0 ? void 0 : store.ID;
        if (appointmentType != BAA.APPOINTMENT.VIRTUAL) {
            values.appointmenttype = availableSlotTypes;
        }
        if (values.appointmenttype == BAA.APPOINTMENT.VIRTUAL && values.reason == BAA.REASONS.PERSONALIZATION) {
            values.reason = undefined;
        }
    };
    const validate = async (values, onSubmit) => {
        // if (window.loggedin) {
        //   values.privacyFlag = true;
        // }
        prefillValues(values);
        // In order to keep full validation of all the form and the automatic assignment of the current country in the countrySelect, there are multiple validation calls that occour on re-renderings.
        // When the validation is called with the same values as the last one, nothing is returned. In each and every case of this specific form we will have a subsequential validation that will generate a valid response, so no problems will arise.
        // This code can address the issue described in the ticket OE-17125 only, do not use it elsewhere.
        let different = false;
        if (lastArg.current) {
            new Set([...Object.keys(lastArg.current), ...Object.keys(values)]).forEach((valKey) => {
                if ((values[valKey] || '') !== (lastArg.current[valKey] || ''))
                    different = true;
            });
        }
        else {
            different = true;
        }
        if (different || onSubmit) {
            lastArg.current = values;
            return await formutils.validateForm(values, formdef, 'bookanappointment');
        }
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values, true);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        await api.bookAnAppointmentSubmit(values, formdef).then((data) => {
            // console.log('after submit: ' + JSON.stringify(data, null, 2));
            if (typeof data === 'undefined') {
                // -- setShowOverlay(false) if same appointment ?
                return;
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
                return;
            }
            // https://jira.industries-group.com/browse/MOM-3264
            // let errors: models.ValidationErrors = {};
            // if (!formutils.checkValidationAfterSubmit(data, errors)) {
            //   return errors;
            // }
            // if (props.type != 'mbm') {
            //   // -- not mbm
            //   // analytics.bookAppointmentSubmit(props.product?.masterId);
            //   analytics.storelocatorBookAppointment(['modal', 'mbm'].includes(props.type) ? 'storelocator' : 'footer', `submit-moncler ${store.name}`);
            // }
            // else {
            //   if (props.paletteName) {
            //     // -- configuration
            //     analytics.configuratorAction(props.fromContinueInStore ? 'continue in store' : 'product configuration', props.paletteName() + '-confirm appointment');
            //   } else {
            //     // -- pdp
            //     analytics.bookAppointmentSubmit(props.product?.masterId);
            //   }
            // }
            setRequestSent(values);
            setAppointmentresponse(data);
            const SCROLL_SELECTOR = props.variant == 'myaccount' ? '.myaccount-hero' : '.cs-hero';
            document.querySelector(SCROLL_SELECTOR).scrollIntoView({ behavior: 'smooth', inline: 'end' });
        });
    };
    // ANCHOR - CONFIRMATION PAGE --------------------------------------------------------------------
    if (formdef && requestSent && appointmentresponse) {
        return (React.createElement(ClientServiceSection, { title: t('bookanappointment.title'), introSection: true, active: props.variant === 'default' && props.type === 'page' },
            React.createElement(BookAnAppointmentConfirmationPage, Object.assign({ store: store, formdef: formdef, requestSent: requestSent, appointmentresponse: appointmentresponse, days: days }, props))));
    }
    if (!formdef || !initialValues) {
        return React.createElement(React.Fragment, null);
    }
    const renderGuestAdvice = () => (React.createElement("div", { className: "row client-service__baa-guest-advice" },
        React.createElement("div", { className: "col-lg-24" },
            React.createElement("p", null, t('bookanappointment.boxlogin'))),
        React.createElement("div", { className: "col-lg-12" },
            React.createElement(Button, { onClick: () => setLoginOpen(true), type: "button", fullWidth: true }, t('checkout.logincta')))));
    const renderTabs = (form) => (React.createElement(Tabs, { className: "tabs tabs--fluid tabs--capitalize tabs--centered tabs--fit" },
        React.createElement(TabList, { className: classNames('react-tabs__tab-list client-service__tablist', { 'react-tabs__tab-list--overflow': props.type === 'page' }) },
            React.createElement(Tab, { onClick: () => {
                    form.change('appointmenttype', 552250000);
                    setAppointmentType(552250000);
                    // if (tabsMap) {
                    //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), tabsMap['552250000'].toLowerCase());
                    // }
                } }, t('bookanappointment.appointmentinstore')),
            !window.faf && !window.appmode && !window.isClothing && props.virtualAppointmentEnabled && (React.createElement(Tab, { onClick: () => {
                    form.change('appointmenttype', 552250001);
                    setAppointmentType(552250001);
                    // if (tabsMap) {
                    //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), tabsMap['552250001'].toLowerCase());
                    // }
                } }, t('bookanappointment.virtualappointment')))),
        React.createElement(TabPanel, { className: "client-service__tabpanel--baa" },
            React.createElement(React.Fragment, null)),
        props.virtualAppointmentEnabled && (React.createElement(TabPanel, { className: "client-service__tabpanel--baa" },
            React.createElement(React.Fragment, null)))));
    const renderForm = () => (React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, validate: validate, decorators: [focusOnError], mutators: {
            global: formutils.globalMutator,
            resetHours: (args, state, utils) => {
                utils.changeValue(state, 'hour', () => null);
            },
        }, render: ({ handleSubmit, form, submitting, values }) => {
            var _a;
            return (React.createElement("form", { onSubmit: handleSubmit, className: classNames('d-column', { 'row-gap-40 row-gap-lg-60': props.type == 'page' }, { 'row-gap-20': props.type === 'modal' }) },
                props.type == 'page' && props.variant === 'myaccount' ? (React.createElement("div", { className: "row row-appointmenttype" },
                    React.createElement("div", { className: "col-24" },
                        React.createElement(DwFormField, { def: formdef, name: "appointmenttype", type: "optionbox", groupClassName: "optionbox--tabs", onChange: (e) => {
                                setAppointmentType(e.target.value);
                                // if (tabsMap) {
                                //   analytics.clientServiceRedesignAnalytics(`${props.pagetitleforanalytics}`.toLowerCase(), tabsMap[e.target.value as keyof typeof tabsMap].toLowerCase());
                                // }
                            } })))) : (renderTabs(form)),
                window.loggedin ? (React.createElement(React.Fragment, null,
                    props.type == 'modal' && (React.createElement(React.Fragment, null,
                        React.createElement(ProductBoutiqueSelected, { appointmentType: values.appointmenttype, store: store, onArrowBack: props.onArrowBack, type: props.type }),
                        React.createElement("p", { className: "yourdetails-title" }, t('bookanappointment.yourdetails')))),
                    props.type == 'page' && (React.createElement(React.Fragment, null,
                        values.appointmenttype == BAA.APPOINTMENT.VIRTUAL && (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-24 col-lg-12" },
                                React.createElement("p", { className: "virtual-message" }, t('bookanappointment.virtualappointmentmsg'))))),
                        values.appointmenttype && (React.createElement(BookAnAppointmentStoreSelector, Object.assign({ formdef: formdef, initialValues: initialValues }, props, { mutator: form.mutators.global, store: store, onSelect: setStore, appointmentType: values.appointmenttype, showmap: values.appointmenttype != BAA.APPOINTMENT.VIRTUAL, setReasonSelect: setReasonSelect, setAvailableSlotTypes: setAvailableSlotTypes, resetFields: resetFields }))))),
                    React.createElement("div", { className: "ReserveForm d-column row-gap-40" },
                        React.createElement(BookAnAppointmentDateSelection, { formdef: formdef, days: days, values: values, type: props.type, form: form }),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-24" },
                                React.createElement(DwFormField, { def: formdef, name: "reason", type: "select", options: values.appointmenttype != BAA.APPOINTMENT.VIRTUAL
                                        ? formdef.reason.options
                                        : formdef.reason.options.filter((o) => o.value != BAA.REASONS.PERSONALIZATION) }))),
                        values.reason == BAA.REASONS.DISCOVERCOLLECTION && (collections === null || collections === void 0 ? void 0 : collections.length) > 0 && (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-24" },
                                React.createElement(DwFormField, { def: formdef, name: "collectionCode", type: "select", options: [{ value: '', label: t('label.select') }].concat(collections) || [] })))),
                        values.appointmenttype == BAA.APPOINTMENT.VIRTUAL && props.type == 'page' && (React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-24 col-lg-12" },
                                React.createElement("p", { className: "yourdetails-title" }, t('bookanappointment.yourdetails'))))),
                        React.createElement(BookAnAppointmentReasonMessage, { formdef: formdef, values: values }),
                        React.createElement(BookAnAppointmentPersonalInfo, { formdef: formdef }),
                        React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-24" },
                                    React.createElement(DwFormField, { def: formdef, name: "email", type: "email" })))),
                        React.createElement("div", null,
                            React.createElement(DwFormFieldPhoneWithPrefix, { def: formdef, uniqueLabel: t('profile.phonenumber'), hideValidTick: true }))),
                    React.createElement("div", { className: classNames('d-column row-gap-40', { 'row-gap-lg-20': props.type == 'modal' }) },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-24" },
                                React.createElement(DwFormField, { def: formdef, name: "privacyFlag", type: "checkbox" }))),
                        React.createElement("div", { className: "row button-row align-middle" },
                            React.createElement("div", { className: "col-fill wrapper-button-arrow" }, props.type == 'page' && props.variant == 'myaccount' && (React.createElement("a", { href: props.manageappointmenturl, className: "button button--tertiary" },
                                React.createElement("span", null, t('button.cancel'))))),
                            React.createElement("div", { className: classNames('col-24', { 'col-lg-9 col-xxl-8': props.type == 'page' }) },
                                React.createElement(SubmitButton, { submitting: submitting, label: props.type == 'page' ? t('bookanappointment.confirmappointment') : props.type == 'modal' && t('button.submit'), fullWidth: true }))),
                        React.createElement(ErrorBox, { errors: errors }),
                        React.createElement("p", { className: "product-reserve__detail__form__note" },
                            React.createElement("small", { className: "note", dangerouslySetInnerHTML: { __html: t('notifyme.termsandconditions', { 0: (_a = document.getElementById('hidden-cookieurl')) === null || _a === void 0 ? void 0 : _a.href }) } }))))) : (props.variant === 'default' && renderGuestAdvice())));
        } }));
    return (React.createElement(React.Fragment, null,
        React.createElement(ClientServiceSection, { title: t('bookanappointment.title'), introSection: true, active: props.variant === 'default' && props.type === 'page' },
            React.createElement("div", { ref: appointmentSection, className: "product-reserve__detail__form " },
                props.variant === 'default' && props.type === 'page' && React.createElement("p", { className: "mb-60 mb-lg-80" }, t('bookanappointment.intro')),
                renderForm()),
            React.createElement(LoginModal, Object.assign({}, props, { inCart: true, reloadPageRegisteredInStore: true, modalStatus: loginOpen, analyticsKey: "modal", updateStatus: (status) => setLoginOpen(status) })))));
};
BookAnAppointmentForm.defaultProps = {
    variant: 'default',
};
export default BookAnAppointmentForm;
